<template>
  <section class="bg-color">
    <div class="container blog-display">
      <div class="inner-blog">
        <div class="row">
          <div class="col-md-8">
            <div class="about-blog">
              <h1 class="blog_title">{{fetchedData.attributes.title}}</h1>
              <div class="blog_content">
              <big v-html="this.$options.filters.convertUrlImage(fetchedData.attributes.description)">

              </big>
            </div>
            </div><!-- end about-blog -->
          </div><!-- end col -->
          <div class="col-md-4">
            <popular></popular>
          </div><!-- end col -->
        </div><!--end row -->
      </div><!-- end inner-blog -->
    </div><!-- end blog-display -->
  </section>
</template>

<script>
import {HTTP} from '../http-common.js'
import * as moment from 'moment-timezone';
import Popular from './Popular.vue'

export default {
  name: 'about',
  data () {
    return {
      fetchedData: {
        attributes:{
          title:'',
          description:''
        }
      },
      error: false,
    }
  },
  filters: {
  	truncate: function(string, value=150) {
      if(string.length <= value) {
       return string;
       }
       else {
           return string.substring(0, value) + '...';
       }

    },
    escape: function(text){
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    },
    convertDate: function(date){
      return moment(date).format('MMMM Do, YYYY')
    },
    convertUrlImage:function(text){
      return text.replace("/uploads/filemanager", "https://dev.drishtiair.com/uploads/filemanager");
    }
  },
  mounted: function(){
      this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var itemId = this.$route.params.id;
                var url = 'page/'+itemId
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedData = jsonData.data.data
                    //console.log(this.fetchedData)
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  },
  components: {
      Popular
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?51a04baa